import {
  FontColorEnum,
  FormField,
  FormHint,
  IconButtonSection,
  IconSizeEnum,
  PlusIcon,
} from '@acceso/design-system';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';

type TDrawnVideo<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  required?: boolean;
  onClick?: () => void;
};
export function DrawnVideo<T extends FieldValues>({
  form,
  name,
  required,
  onClick,
}: TDrawnVideo<T>) {
  const { setDrawerLogo } = useBroadcastScheduleProgram();
  const { t } = useTranslation();

  const handleClickAddDrawn = () => {
    setDrawerLogo(prev => !prev);
    onClick && onClick();
  };

  return (
    <FormField>
      <Controller
        name={name}
        control={form.control}
        rules={{
          required: required
            ? { value: true, message: t('Debes seleccionar un delimitador en el video') }
            : false,
        }}
        render={({ fieldState: { error } }) => (
          <>
            <div className="w-full flex-col">
              <div className="flex justify-end py-size-8">
                <IconButtonSection
                  className="mr-size-16"
                  onClick={handleClickAddDrawn}
                  internalProps={{
                    icon: {
                      size: IconSizeEnum.SM,
                      type: PlusIcon,
                    },
                    text: {
                      value: t('Editar cuadro delimitador'),
                      color: FontColorEnum.Default,
                    },
                  }}
                />
              </div>
            </div>
            {error && (
              <FormHint color={FontColorEnum.Error20} type="error">
                {error.message}
              </FormHint>
            )}
          </>
        )}
      />
    </FormField>
  );
}
